


















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import Transaccion from "@/models/tarjeta/transaccion.model";
import TipoTramite from "@/models/tipoTramite";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BTableColumn from "@/models/base/BTableColumn.model";
import TramiteTransaccionNoAutorizadaModel from "@/models/tramite/reclamo/transaccion-no-autorizada.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import moment from "moment";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
@Component
export default class ConsumoNoAutorizadoResumen extends  GenericBTable<TramiteTransaccionNoAutorizadaModel> {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;

  get tramiteBeneficiarioId() {
    if (this.content && this.content.id) return this.content.id;
    if (this.$route.params.id) return this.$route.params.id;
    return 0;
  }
  created() {
    this.tableConfig.controller = "TramiteTransaccionNoAutorizada";
    this.tableConfig.include = "Transaccion.Tarjeta.Banco|Transaccion.Subsidio|Transaccion.Comercio";
    this.tableConfig.activeActions = false;
    this.tableConfig.detailed = true;
    this.tableConfig.whereParams = this.getWhereParams();
    this.formatColumns();
  }
  getWhereParams() {
    let result = [];
    result.push(
      `tramiteBeneficiarioId="${this.tramiteBeneficiarioId}"`
    );

    return result.join("&");
  }
 formatColumns() {
    let monto = new BTableColumn("transaccion.monto", "Monto", false);
    monto.customTemplate = true;
    monto.templateSlot = 'monto';
    let subsidio = new BTableColumn("transaccion.subsidioNombre", "Subsidio", false);
    subsidio.customTemplate = true;
     subsidio.templateSlot = 'subsidioNombre';
    let fecha = new BTableColumn("transaccion.fechaTransaccion", "Fecha de transacción");
    fecha.type = BTableColumnType.Date;
    let comercio = new BTableColumn("transaccion.comercioNombre", "Comercio");
    this.tableConfig.insertColumns(monto, subsidio, comercio, fecha);
   // if(this.hogarId)
    //this.buscar();
  }
}
